const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

//ページTOP
const pageTop = () =>{
  const topBtn = $('.sw-Top');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//export
export { anchorScroll, pageTop };


// WEBPACK FOOTER //
// module.js